import React from "react";
import { TestLeadForm } from "../../components/TestLeadForm.jsx";
import QuotePoolCta from "../../components/QuotePoolCta.jsx";

export default function LeadFormSection({
  renderedImageUrls, placementUrl, onRefreshPreview,
  quoteOpen, setQuoteOpen,
}) {
  return (
    <>
      <div className="section">
        <div className="label">Send to artist</div>
        <TestLeadForm
          renderedImageUrls={renderedImageUrls || []}
          placementUrl={placementUrl}
          onRefreshPreview={onRefreshPreview}
        />
      </div>

      <div className="section">
        <button
          type="button"
          className="tt-quote-toggle"
          onClick={() => setQuoteOpen((open) => !open)}
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: 8,
            width: "100%",
            padding: "6px 0",
            background: "#C92D2D",
            border: "none",
            color: "inherit",
            cursor: "pointer",
          }}
        >
          <span
            className="label"
            style={{
              marginBottom: 0,
              textTransform: "uppercase",
              fontSize: 11,
              letterSpacing: 0.12,
              opacity: 0.9,
            }}
          >
            Get quotes from Tattune artists
          </span>
          <span style={{ fontSize: 14, opacity: 0.8 }}>
            {quoteOpen ? "▾" : "▸"}
          </span>
        </button>

        {quoteOpen && (
          <div style={{ marginTop: 8 }}>
            <QuotePoolCta
              renderedImageUrls={renderedImageUrls || []}
              placementUrl={placementUrl}
              onRefreshPreview={onRefreshPreview}
            />
          </div>
        )}
      </div>
    </>
  );
}
